import React, { useEffect} from "react";

import { FxmsData } from "../../fxms/datas/FxData";
import { getNow } from "../common/commonMethod";

export const WeatherInfo = (props) => {

  const [weatherList, setWeatherList] = React.useState([]);
  const dong = FxmsData.getDongInfo();
  const user = FxmsData.getUser();

  // 관리자(1020)면 모든 지역, 아니면 본인 지역만
  const isAdmin = user.ugrpNo === 1020;

  const allAreaNums = [
    { areaNum: "4127310400", name: "경기도 안산시 단원구 성곡동" },
    { areaNum: "4139013200", name: "경기도 시흥시 정왕동" },
    { areaNum: "2826011900", name: "인천광역시 서구 오류동" }
  ];

  const getWeather = async() => {
    const currentTime = getNow().slice(0,10)+"0000";
    let targets = [];
  
    if (isAdmin) {
      targets = allAreaNums;
    } else if (user.areaNum) {
      targets = [{ areaNum: user.areaNum, name: dong?.areaAllName || "" }];
    }
  
    const results = [];
    for (const target of targets) {
      const uri = "h2/getWeatherData/" + target.areaNum + "/" + currentTime;
      const res = await FxmsData.GET(uri);
      if (res.data.length !== 0) {
        const weaterData = res.data[0];
        results.push({
          ...weaterData,
          areaName: target.name,
          icon: getWeatherIcon(weaterData.weatCd)
        });
      }
    }
    setWeatherList(results);
  };

  const getWeatherIcon = (weater) =>{
    if(weater==="맑음") return "sun"
    else if(weater==="구름많음") return "clouds"
    else if(weater==="비") return "rain"
    else if(weater==="눈") return "snow" 
    else if(weater==="흐림") return "cloud" 
    else if(weater==="비/눈") return "rainsnow"  //비/눈, 구름많음 아이콘 추가 필요
  }

  useEffect(()=>{   
    getWeather();
  }, [])

  return (
    <>
      <div className="VUPLeftWeather">
        {weatherList.length > 0 ? (
          weatherList.map((w, idx) => (
            <dl key={idx}>
              <dt className={w.icon}></dt>
              <dd>
                <ul>
                  <li><strong>{w.areaName}</strong></li>
                  <li>{w.weatCd}</li>
                  <li>온도 {w.tempVal}°C</li>
                  <li>습도 {w.humiVal}%</li>
                </ul>
              </dd>
            </dl>
          ))
        ) : (
          <dl>
            <dd className="VUPLeftWeatherNoData">
              <ul>
                <li>날씨 주소 정보 없음</li>
              </ul>
            </dd>
          </dl>
        )}
      </div>
    </>
  );
};
